// =============================================================
// UTILITY FUNCTIONS
// =============================================================

/**
 * Merge CSS class names, filtering out falsy values.
 * Lightweight alternative to clsx for simple use-cases.
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ')
}

/**
 * Format a phone number for display
 */
export function formatPhone(phone: string): string {
  return phone.replace(/(\d{4})(\d{3})(\d{4})/, '$1-$2-$3')
}

/**
 * Scroll smoothly to a section by ID
 */
export function scrollToSection(id: string): void {
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

